import * as React from 'react';
import { Typography, styled } from '@mui/material';
import Column from 'src/frontend-common/components/Column';

const Spacer = styled(Column)(({ theme }) => ({
  marginBottom: theme.spacing(5),
}));

const StatusImg = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: 150,
  height: 'auto',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    height: 150,
  },
}));

const Title = styled(Typography)(({}) => ({
  fontSize: 40,
  fontWeight: 600,
  lineHeight: 1.2,
  color: '#000000',
  marginBottom: 20,
  textAlign: 'center',
}));

const Subtitle = styled(Typography)(({}) => ({
  fontSize: 14,
  fontWeight: 400,
  color: '#616161',
  lineHeight: 1.1,
  textAlign: 'center',
}));

interface PropTypes {
  title: string;
  content: string;
  children?: React.JSX.Element | React.JSX.Element[] | string;
  image?: { src: string; alt: string };
}

const CourtesyPage: React.FC<PropTypes> = ({ children, title, content, image }) => {
  return (
    <>
      {image ? (
        <Spacer centered>
          <StatusImg src={image.src} alt={image.alt} />
        </Spacer>
      ) : null}
      <Spacer centered>
        <Title variant="h3" style={{ color: 'black' }}>
          {title}
        </Title>
        <Subtitle variant="body2">{content}</Subtitle>
      </Spacer>
      {children}
    </>
  );
};

export default CourtesyPage;
